<script setup lang="ts">
import { OUTPUT_TIME_LIST } from "@/services/consts/every_24_hours_report";
import { computed } from "vue";
import i18n from '@/lang/i18n';

const emit = defineEmits(['update:modelValue']);

const props = defineProps<{
  modelValue: string
  index: number
  downloading: boolean
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <div
    class="col-5 d-flex"
  >
    <div class="col-2 mx-3 my-auto padding-top-2px">
      <h5 class="mt-2 font-weight-bold text-grey-darken-3">
        {{ i18n.global.t('pages.every24HoursReport.preview.outputTime') }}
      </h5>
    </div>
    <div class="col-10 ml-2 mt-4 font-weight-bold text-grey-darken-4">
      <v-radio-group
        v-model="modelValue"
        :disabled="props.downloading"
        inline
      >
        <template v-for="(outputTime, key) in OUTPUT_TIME_LIST" :key="key">
          <v-radio
            :id="`output-time-${key}-${props.index}`"
            class="ml-2 font-weight-bold"
            :class="`output-time-${props.index}`"
            :label="outputTime.label"
            :for="`${key}-${props.index}`"
            :name="`output-time-${props.index}`"
            :value="outputTime.value"
            color="blue-darken-1"
            style="font-size: 18px;"
          />
        </template>
      </v-radio-group>
    </div>
  </div>
</template>
